import React from 'react';
import PropTypes from 'prop-types';

import { SHIPMENT_TRACKING_DATE_FORMAT } from 'constants/appConstants';
import { formatDate, parseDate } from 'helpers/dateUtils';
import { groupBy } from 'helpers/lodashReplacement';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import useMartyContext from 'hooks/useMartyContext';

import styles from 'styles/components/account/trackingEvents.scss';

export const TrackingEvents = ({ events }) => {
  const { testId } = useMartyContext();
  const trackingEventsByDate = groupBy(events, ({ date }) => formatDate('dddd, MMM DD, YYYY', parseDate(date, SHIPMENT_TRACKING_DATE_FORMAT)));

  return (
    <div className={styles.trackingEvents} data-test-id={testId('shipmentTrackingEvents')}>
      {Object.keys(trackingEventsByDate).map((date, index) => (
        <div key={index} className={styles.trackingEvent}>
          <h2>{date}</h2>
          <div>
            {trackingEventsByDate[date].map((event, index) => {
              const { date, location, description } = event;
              return (
                <div key={index} className={styles.dailyEvent}>
                  <div className={styles.time}>{formatDate('hh:mm A', parseDate(date, SHIPMENT_TRACKING_DATE_FORMAT))}</div>
                  <div className={styles.desciptionLocation}>
                    <span>{description}</span>
                    <span className={styles.location}>{location}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

TrackingEvents.contextTypes = {
  testId: PropTypes.func
};

TrackingEvents.propTypes = {
  events: PropTypes.array.isRequired
};

TrackingEvents.displayName = 'TrackingEvents';

export default withErrorBoundary(TrackingEvents.displayName, TrackingEvents);
